// set new favicon
// `faviconURL` should be url to ico file
export function setFavicon(faviconURL) {
  let favicon = document.getElementById("favicon");

  favicon.href = faviconURL;
}
